(function() {
    'use strict';

    angular
        .module('nasracApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('archivedbilling', {
            abstract: true,
            parent: 'app'
        }).state('archivedbilling-main', {
            abstract: true,
            parent: 'archivedbilling',
            url: '/archivedbilling-main',
            data: {
                authorities: ['ROLE_USER'],
               /* pageTitle: 'nasracApp.nonnctc.home.title'*/
            },
            views: {
                'content@': {
                    templateUrl: 'app/archived-billing/archivedbilling.html',
                    controller: 'ArchivedBillingMainController',
                    controllerAs: 'vm'
                }
            }
        }).state('archivedbilling-main.archived-nonnctc', {
            url:         '/archived-nonnctc',
            templateUrl: 'app/archived-billing/templates/archived-nonnctc.html',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'nasracApp.archived-nonnctc.home.title'
            },
            controller: 'ArchivedBillingMainController',
            controllerAs: 'vm',
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    //$translatePartialLoader.addPart('archived-nonnctc');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        }).state('archivedbilling-main.archived-nctc', {
            url:         '/archived-nctc',
            templateUrl: 'app/archived-billing/templates/archived-nctc.html',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'nasracApp.archived-nctc.home.title'
            },
            controller: 'ArchivedBillingMainController',
            controllerAs: 'vm',
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                   // $translatePartialLoader.addPart('archived-nctc');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        }).state('archivedbilling-main.archived-dta', {
            url:         '/archived-dta',
            templateUrl: 'app/archived-billing/templates/archived-dta.html',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'nasracApp.archived-dta.home.title'
            },
            controller: 'ArchivedBillingMainController',
            controllerAs: 'vm',
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                   // $translatePartialLoader.addPart('archived-dta');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        }).state('archivedbilling-main.archived-revenue', {
            url:          '/archived-revenue',
            templateUrl: 'app/archived-billing/templates/archived-revenue.html',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'nasracApp.archived-revenue.home.title'
            },
            controller: 'ArchivedBillingMainController',
            controllerAs: 'vm',
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    //$translatePartialLoader.addPart('archived-revenue');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });

    }
})();
